import { defaultFormAddress, ukraineOption } from '../../constants';
import {
  AccessAfterAuthorityExpiration,
  AuthorityTermType,
  TManagersAndRepresentatives,
} from './types';

export const EMPTY_ASSET_MANAGER = {
  id: null,
  lastName: '',
  firstName: '',
  middleName: '',
  identificationNumber: '',
  foreignTaxNumber: '',
  position: null,
  contactNumbers: [''],
  emailAddress: [''],
  signatureAuthorityDetails: null,
  verificationStatus: '',
  authorityTermType: null,
  authorityExpirationDate: null,
  accessAfterAuthorityExpiration: null,
  isHead: false,
};

export const EMPTY_CLIENT_REPRESENTATIVE = {
  lastName: '',
  firstName: '',
  middleName: '',
  identificationNumber: '',
  foreignTaxNumber: '',
  citizenshipCountry: ukraineOption,
  residenceCountry: ukraineOption,
  address: defaultFormAddress,
};

export const isUnifiedAccountAccessTextTooltip =
  'Оберіть “Однаковий доступ до всіх рахунків”, щоб усі розпорядники мали право підпису за всіма рахунками. ' +
  'Перевірте перелік осіб і їхні права у згенерованому документі. Оберіть «Роздільний доступ до рахунків», ' +
  'щоб розмежувати доступ окремим особам до конкретних рахунків. Додатково завантажте заповнену форму на кроці "Документи".';

export const isUnifiedAccountAccessButtonTooltip =
  'Рекомендація щодо заповнення та подання Переліку осіб з правами доступу до рахунків: ' +
  'Заповніть шаблон документу: завантажте шаблон та внесіть до нього перелік осіб і номери рахунків, ' +
  'якими вони уповноважені розпоряджатися. Проконтролюйте склад розпорядників: якщо для керування різними ' +
  'рахунками передбачено різні групи осіб, підготуйте окремий документ для кожного такого випадку. Надайте документ: ' +
  'завантажте всі сформовані файли до блоку “Додаткові документи”. Впровадження змін: ' +
  'Повноваження розпорядників будуть встановлені банком згідно з заповненим документом після підписання її КЕП ' +
  'та перевірці в Банку.';

export const accessAfterAuthorityExpirationOptions = [
  {
    value: AccessAfterAuthorityExpiration.ACCESS_DENIED,
    label: 'Вхід заборонено',
  },
  {
    value: AccessAfterAuthorityExpiration.LOGIN_ALLOWED_SIGNING_DENIED,
    label: 'Вхід дозволено, підписання заборонено',
  },
];

export const authorityTermTypeOptions = [
  {
    value: AuthorityTermType.UNLIMITED,
    label: 'Безстроково',
  },
  {
    value: AuthorityTermType.UNTIL_DATE,
    label: 'Встановити дату терміну дії повноважень (по включно)',
  },
];

export const testDataManagersAndRepresentatives: TManagersAndRepresentatives = {
  assetManagers: [],
  isUnifiedAccountAccess: true,
  isClientRepresentativesAbsent: false,
  isAnyAssetManagerDataChanged: false,
  clientRepresentatives: [
    {
      lastName: 'Шевченко',
      firstName: 'Тарас',
      middleName: 'Григорович',
      identificationNumber: '1234567890',
      foreignTaxNumber: null,
      citizenshipCountry: ukraineOption,
      residenceCountry: ukraineOption,
      address: {
        registrationAddress: {
          address: 'Україна, 12345, м.Київ, вул. Хрещатик, 22',
          country: ukraineOption,
          postalCode: '12345',
          region: { value: '26', label: 'м.Київ' },
          district: null,
          city: { label: 'м.Київ', value: '191919' },
          street: { label: 'вул. Хрещатик', value: '25979' },
          houseNumber: '22',
          building: null,
          apartment: null,
          codeAddress: 'UA80000000000093317',
        },
        permanentAddress: {
          address: 'Україна, 12345, м.Київ, вул. Хрещатик, 22',
          country: ukraineOption,
          postalCode: '12345',
          region: { value: '26', label: 'м.Київ' },
          district: null,
          city: { label: 'м.Київ', value: '191919' },
          street: { label: 'вул. Хрещатик', value: '25979' },
          houseNumber: '22',
          building: null,
          apartment: null,
          codeAddress: 'UA80000000000093317',
        },
        coincidences: true,
      },
    },
  ],
};
